import { render, staticRenderFns } from "./RegisterNewUser.vue?vue&type=template&id=0d8ea252"
import script from "./RegisterNewUser.vue?vue&type=script&lang=js"
export * from "./RegisterNewUser.vue?vue&type=script&lang=js"
import style0 from "./RegisterNewUser.vue?vue&type=style&index=0&id=0d8ea252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports